import React, { Component } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
} from "devextreme-react/form";
import { Button } from "devextreme-react";
import notify from "devextreme/ui/notify";
import {
  criarGrupoRecursoDs,
  inserirOuAtualizar,
} from "../../DataSources";
import Memoria from "../../Memoria";
import api from "../../api-axios";
import UserInfo from "../../UserInfo";
import {
  DataGrid,
  Column,
  Selection,
  Paging,
} from "devextreme-react/data-grid";
import ShowError from "../../AppServices";

export default class GrupoRecursoForm extends Component {
  constructor(props) {
    super(props);

    const gerenciaPrefeitura = UserInfo.gerenciaPrefeitura();
    const eAdm = UserInfo.possuiSubPerfil("adm");

    this.state = {
      gestor: UserInfo.gerenciaPrefeitura() ? "2" : "1",
      gestorBloqueado: !(gerenciaPrefeitura && eAdm),
      recursoId: "",
      _uiRecurso: "",
      permissoesCarregadas: [],
      permissoesSelecionadas: [],
    };

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.grupoRecursoDs = criarGrupoRecursoDs();

    this.gestorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: "1", descricao: "PREFEITURA" },
        { id: "2", descricao: "TRIMAP" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  async componentDidMount() {
    const response = await api.get("/recursos_seguranca/");

    console.log("resp recurso", response);

    if (this.props.match.params.id) {
      const grupoResponse = await this.grupoRecursoDs.byKey(
        this.props.match.params.id
      );

      console.log("grupo response", grupoResponse);

      let gruposIds = [];

      if (grupoResponse.permissoes) {
        gruposIds = grupoResponse.permissoes
          .split(",")
          .map((x) => x.trim())
          .map((x) => Number(x));

        console.log("grupos ids", gruposIds);
        gruposIds = response.data.data.filter((x) => gruposIds.includes(x.id));
        console.log("grupos ids filtrados", gruposIds);
      }

      this.setState({
        ...grupoResponse,
        permissoesCarregadas: response.data.data,
        permissoesSelecionadas: gruposIds,
      });

      console.log(this.state);
    } else {
      this.setState({
        permissoesCarregadas: response.data.data,
      });
    }
  }

  renderPermissoes = () => {
    return (
      <div
        style={{
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "lightgray",
        }}
      >
        <DataGrid
          dataSource={this.state.permissoesCarregadas}
          width={"100%"}
          selectionMode="multiple"
          showBorders={true}
          key={"id"}
          selectedRowKeys={this.state.permissoesSelecionadas}
          onSelectionChanged={(e) => {
            this.setState({
              ...this.state,
              permissoesSelecionadas: e.selectedRowsData,
            });
          }}
        >
          <Paging enabled={false} />
          <Column dataField={"nome"} caption={"Recursos"} />
          <Selection
            mode="multiple"
            selectAllMode="allPages"
            showCheckBoxesMode="always"
          />
        </DataGrid>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem
                caption="Novo Grupo de Recurso"
                colSpan={2}
                colCount={4}
              >
                <SimpleItem colSpan={2} dataField={"nome"}>
                  <Label text="Nome" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"gestor"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.gestorOptions}
                  disabled={this.state.gestorBloqueado}
                >
                  <Label text="Gestor" />
                </SimpleItem>
                <SimpleItem colSpan={4} render={this.renderPermissoes}>
                  <Label text="Permissões" visible={false} />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    console.log("prefeitura", UserInfo.getPrefeitura());
    const prefeitura = UserInfo.getPrefeitura();

    if (
      (this.state.gestor.toString() === "1" && !prefeitura) ||
      prefeitura === 0
    ) {
      notify("Selecione uma prefeitura para grupo", "error");
      return;
    }
    const gruposFinal = [];

    for (let permissao of this.state.permissoesSelecionadas) {
      if (typeof permissao === "number") {
        gruposFinal.push(permissao);
      } else {
        gruposFinal.push(permissao.id);
      }
    }

    const entidade = {
      id: this.state.id,
      nome: this.state.nome,
      gestor: this.state.gestor,
      permissoes: gruposFinal.join(","),
      prefeituraId: this.state.gestor.toString() === "1" ? prefeitura : null,
    };

    inserirOuAtualizar(this.grupoRecursoDs, entidade)
      .then(
        function () {
          notify("Grupo de Recurso cadastrado com sucesso.", "success");
          Memoria.removerEdicao(this.props.location);
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
